<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="selectModuleCode"
              :pageId="this.$options.name"
              :selectedMd="searchFrame.selectedCodeValue.moduleCode"
              :selectedSmd="searchFrame.selectedCodeValue.subModuleCode"
              :defaultSmdOption="'all'"
              class="dp_flex"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_METHOD')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="selectDataServiceTypeCode"
              :selected="searchFrame.selectedCodeValue.dataServiceTypeCode"
              :pageId="this.$options.name"
              codeId="COD_DTSVC_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DTSVC_STT')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="selectDataServiceStateCode"
              :selected="searchFrame.selectedCodeValue.dataServiceStateCode"
              :pageId="this.$options.name"
              codeId="COD_DTSVC_STT"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="selectDataServiceCommunicationTypeCode"
              :selected="searchFrame.selectedCodeValue.dataServiceCommunicationTypeCode"
              :pageId="this.$options.name"
              codeId="COD_DTSVC_CMNC_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <!-- YnSelect customlist 추가 -->
            <sui-yn-select
              ref="selectDataServiceUseYn"
              :selected="searchFrame.selectedCodeValue.dataServiceUseYn"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="selectDataServiceSearchCond"
              :selected="searchFrame.selectedCodeValue.dataServiceSearchCond"
              :pageId="this.$options.name"
              codeId="COD_DTSVC_SEARCH_COND"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="searchFrame.dataServiceSearchWord"
              maxlength="50"
              @keyup="onKeyUpInput"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <!-- <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_DTSVC_LIST") }}</h4>
      </div> -->
      <sui-grid
        ref="mainGrid"
        :dataset="'dsMain'"
        :columns="gridColumns"
        :showDisplayCountControl="false"
        @rowselect="onGridSelected"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="this.$options.name"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onExcelDnLoad"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>

      <div class="mrB30" />
      <!-- <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_DTSVC_DTL_INFO") }}</h4>
      </div> -->
      <sui-page-tab-box-type
        ref="tabs"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        :tabItems="tabItems"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :dataServiceIdentification="dataServiceIdentification"
          :pageId="this.$options.name"
          @onClearSelectionMainGrid="onGridClear"
          @research="onSearchClick"
          @page-deactivate="handleChildDeactivated"
          @page-activate="handleChildActivated"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import tab01 from './components/PGE_CMU_00002_T01';
import tab02 from './components/PGE_CMU_00002_T02';
import tab03 from './components/PGE_CMU_00002_T03';
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];
export default {
  name: 'PGE_CMU_00002', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    tab02,
    tab03,
  },
  extends: BasePage,
  data() {
    return {
      searchFrame: {
        selectedCodeValue: {
          moduleCode: {
            label: '',
            key: '',
          },
          subModuleCode: {
            label: '',
            key: '',
          },
          dataServiceCommunicationTypeCode: {
            label: '',
            key: '',
          },
          dataServiceTypeCode: {
            label: '',
            key: '',
          },
          dataServiceStateCode: {
            label: '',
            key: '',
          },
          dataServiceSearchCond: {
            label: '',
            key: '',
          },
          dataServiceUseYn: {
            label: '',
            key: '',
          },
        },
        dataServiceSearchWord: '',
      },
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_DTSVC'),
          tabComponent: tab01,
        },
        {
          tabTitle: this.$t('MSG_TXT_PAGE'),
          tabComponent: tab02,
        },
        {
          tabTitle: this.$t('MSG_TXT_ROLE'), // '권한 상세'
          tabComponent: tab03,
        },
      ],
      currentTabComponent: tab01,
      defaultTabIndex: 0,
      gridColumns: [{
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'dataServiceCommunicationTypeName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_DTSVC_ID'),
        datafield: 'dataServiceIdentification',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_DTSVC_NM'),
        datafield: 'dataServiceName',
      }, {
        text: this.$t('MSG_TXT_DTSVC_URL'),
        datafield: 'dataServiceUniformresourcelocator',
      }, {
        text: this.$t('MSG_TXT_METHOD'),
        datafield: 'dataServiceTypeName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_STT'),
        datafield: 'dataServiceStateName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'dataServiceUseYn',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'm_dsplLngId',
              loginId: 'm_loginId',
              knoxId: 'm_knoxId',
              userId: 'finalModificationUserId',
              userName: 'm_userName',
              userGlobalName: 'm_userGlobalName',
              departmentName: 'm_departmentName',
              departmentEnglishName: 'm_departmentEnglishName',
            },
          }, this.dsMain, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellDateLabel(row, column, value, htmlElement, {
          }, this.dsMain, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
      searchFieldOldText: '',
      dataServiceIdentification: '',
      localdata0: [],
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  datasets: [{
    id: 'dsMain',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'dataServiceName', map: 'dataServiceName' },
      { type: 'string', name: 'pageMetaBasicYn', map: 'pageMetaBasicYn' },
      { type: 'string', name: 'dataServiceCntn', map: 'dataServiceCntn' },
      { type: 'string', name: 'dataServiceUseYn', map: 'dataServiceUseYn' },
      { type: 'string', name: 'dataServiceCommunicationTypeCode', map: 'dataServiceCommunicationTypeCode' },
      { type: 'string', name: 'dataServiceCommunicationTypeName', map: 'dataServiceCommunicationTypeName' },
      { type: 'string', name: 'dataServiceTypeCode', map: 'dataServiceTypeCode' },
      { type: 'string', name: 'dataServiceTypeName', map: 'dataServiceTypeName' },
      { type: 'string', name: 'dataServiceBlockCntn', map: 'dataServiceBlockCntn' },
      { type: 'string', name: 'dataServiceStateCode', map: 'dataServiceStateCode' },
      { type: 'string', name: 'dataServiceStateName', map: 'dataServiceStateName' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'finalModificationUserName', map: 'finalModificationUserName' },
      { type: 'string', name: 'dataServiceIdentification', map: 'dataServiceIdentification' },
      { type: 'string', name: 'dataServicePermissionCode', map: 'dataServicePermissionCode' },
      { type: 'string', name: 'dataServicePermissionName', map: 'dataServicePermissionName' },
      { type: 'string', name: 'firstRegistrationProgramId', map: 'firstRegistrationProgramId' },
      { type: 'string', name: 'finalModificationProgramId', map: 'finalModificationProgramId' },
      { type: 'string', name: 'dataServiceUniformresourcelocator', map: 'dataServiceUniformresourcelocator' },
      { type: 'string', name: 'dataServiceSystemCode', map: 'dataServiceSystemCode' },
      { type: 'string', name: 'dataServiceSystemName', map: 'dataServiceSystemName' },
      { type: 'string', name: 'dataServiceRfcName', map: 'dataServiceRfcName' },
      { type: 'string', name: 'dataServiceExternalUrl', map: 'dataServiceExternalUrl' },
      { type: 'string', name: 'dataServiceServiceId', map: 'dataServiceServiceId' },
      { type: 'string', name: 'r_dsplLngId', map: 'r_dsplLngId' },
      { type: 'string', name: 'r_loginId', map: 'r_loginId' },
      { type: 'string', name: 'r_knoxId', map: 'r_knoxId' },
      { type: 'string', name: 'r_userName', map: 'r_userName' },
      { type: 'string', name: 'r_userGlobalName', map: 'r_userGlobalName' },
      { type: 'string', name: 'r_departmentName', map: 'r_departmentName' },
      { type: 'string', name: 'r_departmentEnglishName', map: 'r_departmentEnglishName' },
      { type: 'string', name: 'm_dsplLngId', map: 'm_dsplLngId' },
      { type: 'string', name: 'm_loginId', map: 'm_loginId' },
      { type: 'string', name: 'm_knoxId', map: 'm_knoxId' },
      { type: 'string', name: 'm_userName', map: 'm_userName' },
      { type: 'string', name: 'm_userGlobalName', map: 'm_userGlobalName' },
      { type: 'string', name: 'm_departmentName', map: 'm_departmentName' },
      { type: 'string', name: 'm_departmentEnglishName', map: 'm_departmentEnglishName' },
    ],
  }],
  methods: {
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },
    onResetClick() {
      this.searchFrame.dataServiceSearchWord = '';
      utils.forEach(this.$refs, (ref, key) => {
        if (utils.startsWith(key, 'select')) {
          ref.reset();
        }
      });
      this.$refs.selectModuleCode.selectMd('CM');
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'dataServiceSearchWord')) {
          data[key] = value;
        } else {
          utils.forEach(this.searchFrame.selectedCodeValue, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        }
      });
      return data;
    },
    onSearchClick() {
      if (!utils.isEmpty(this.dataServiceIdentification)) {
        this.dataServiceIdentification = '';
      }
      const queryParams = this.getSearchData();
      http.request(this.$options.name, 'DTS_CMU_00007', {
        query: queryParams,
      }).then(res => {
        // utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.dsMain.setRawData(this.setUserInfoFormat(res.data));
      }).catch(error => {
        console.log(error);
      });
    },
    // 그리드 데이터 엑셀로 다운로드
    onExcelDnLoad() {
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `dataservice_management_${sToday}.xlsx`;
      const columns = [
        { text: this.$t('MSG_TXT_TYPE'), datafield: 'dataServiceCommunicationTypeName' },
        { text: this.$t('MSG_TXT_MDLE'), datafield: 'moduleName' },
        { text: this.$t('MSG_TXT_SMDLE'), datafield: 'subModuleName' },
        { text: this.$t('MSG_TXT_DTSVC_ID'), datafield: 'dataServiceIdentification' },
        { text: this.$t('MSG_TXT_DTSVC_NM'), datafield: 'dataServiceName' },
        { text: this.$t('MSG_TXT_DTSVC_URL'), datafield: 'dataServiceUniformresourcelocator' },
        { text: this.$t('MSG_TXT_METHOD'), datafield: 'dataServiceTypeName' },
        { text: this.$t('MSG_TXT_STT'), datafield: 'dataServiceStateName' },
        { text: this.$t('MSG_TXT_USE_YN'), datafield: 'dataServiceUseYn' },

        { text: this.$t('MSG_TXT_MDFC_USR'), datafield: 'finalModificationUserName' },
        { text: this.$t('MSG_TXT_MDFC_DTM'), datafield: 'finalModificationDTM' },
      ];
      // utils.downloadGridToExcel(this.$options.name, this.defaultGridData.columns, this.dsMain, sExcelName);
      utils.downloadGridToExcel(this.$options.name, columns, this.dsMain, sExcelName);
    },
    setUserInfoFormat(list) {
      utils.forEach(list, data => {
        utils.forEach(data.firstRegistrationUserInfo, (value, key) => {
          utils.set(data, `r_${key}`, value);
        });
        utils.forEach(data.finalModificationUserInfo, (value, key) => {
          utils.set(data, `m_${key}`, value);
        });
      });
      return list;
    },
    onGridClear() {
      this.dsMain.clearSelection();
    },
    onKeyUpInput() {
      // _ 제외 특수문자 입력제한
      const searchFieldNewText = this.searchFrame.dataServiceSearchWord;
      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.searchFrame.dataServiceSearchWord = this.searchFieldOldText;
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
    onGridSelected(dataRow) {
      if (!utils.isEmpty(dataRow.args.row)) {
        const { dataServiceIdentification } = dataRow.args.row;
        this.dataServiceIdentification = dataServiceIdentification;
      }
    },
  },
};
</script>
<style scoped>
</style>
